import $ from 'jquery'

import form from '../../edit/form/form'

import documentInsert from '../../lib/documentInsert'
import documentUpdate from '../../lib/documentUpdate'
import documentRemove from '../../lib/documentRemove'

import * as timecode from '../../../../lib/timecode'

export function getName(){
  return 'contributor'
}

var rollsByProject = null

export function getTableColumns(o,item){

  var lang = o.store('lang')

  var totalDuration =
    timecode.toSmtp(_.reduce(rollsByProject[item.project], function(sum,roll){
      return sum += timecode.toSeconds(roll.duration) * 1
    }, 0))

  var columns = [
    {
      id: 'project',
      value: item.project,
      type: o.type.text,
      width: 50,
    },
    {
      id: 'duration',
      value: totalDuration,
      type: o.type.timecode,
    },
    {
      id: 'firstName',
      value: item.firstName,
      type: o.type.text,
    },
    {
      id: 'lastName',
      value: item.lastName,
      type: o.type.text,
    },
    {
      id: 'street',
      value: item.street,
      type: o.type.text,
    },
    {
      id: 'number',
      value: item.number,
      type: o.type.number,
      width: 50,
    },
    {
      id: 'zip',
      value: item.zip,
      type: o.type.number,
    },
    {
      id: 'city',
      value: item.city,
      type: o.type.text,
    },
    {
      id: 'tel1',
      value: item.tel1,
      type: o.type.text,
    },
    {
      id: 'tel2',
      value: item.tel2,
      type: o.type.text,
    },
    {
      id: 'email',
      value: item.email,
      type: o.type.text,
    },
    {
      id: 'notes',
      value: item.notes,
      type: o.type.textLong,
    },
    {
      id: 'user',
      value: item.user,
      type: o.type.text,
    },
    {
      id: 'date',
      value: item.date,
      type: o.type.date,
    },
  ]

  return columns

}

export function getTableData(o){

  rollsByProject = _.groupBy(o.data.rolls, function(roll){
    return roll.roll.split('-')[0]
  })

  var data =
    _.map(

      o.data.contributors,

      function(item){

        var model = o.model.contributors
        var columns = model.getTableColumns(o,item)

        var click =
          function(e){
            o.player.load(rollsByProject[item.project][0])
            o.edit.set(item,model)
          }

        return {

          columns: columns,
          click: click,

        }

      }
    )

  return data

}

export function getFormFields(o,item){

  var lang = o.store('lang')

  if(!item){
    var item = {}
  }

  var fields = [
    {
      id: 'project',
      value: item.project,
      type: 'text',
      edit: true,
    },
    {
      id: 'firstName',
      value: item.firstName,
      type: 'text',
      edit: true,
    },
    {
      id: 'lastName',
      value: item.lastName,
      type: 'text',
      edit: true,
    },
    {
      id: 'street',
      value: item.street,
      type: 'text',
      edit: true,
      optional: true,
    },
    {
      id: 'number',
      value: item.number,
      type: 'number',
      edit: true,
      optional: true,
    },
    {
      id: 'zip',
      value: item.zip,
      type: 'number',
      edit: true,
      optional: true,
    },
    {
      id: 'city',
      value: item.city,
      type: 'text',
      edit: true,
      optional: true,
    },
    {
      id: 'tel1',
      value: item.tel1,
      type: 'text',
      edit: true,
      optional: true,
    },
    {
      id: 'tel2',
      value: item.tel2,
      type: 'text',
      edit: true,
      optional: true,
    },
    {
      id: 'email',
      value: item.email,
      type: 'text',
      edit: true,
      optional: true,
    },
    {
      id: 'notes',
      value: item.notes,
      type: 'textLong',
      edit: true,
      optional: true,
    },
  ]

  return fields

}

export function insertForm(o,done){

}

export function insert(o,item,done){

  var data = o.data.contributors
  var collection = 'contributors'

  documentInsert(o,data,item,collection,done)

}

export function update(o,id,changes,done){

  var lang = o.store('lang')

  var data = o.data.contributors
  var collection = 'contributors'

  changes.push({
    id: 'user',
    value: o.store('email'),
  })

  changes.push({
    id: 'date',
    value: new Date(),
  })

  documentUpdate(o,data,id,changes,collection,done)

}



// WEBPACK FOOTER //
// ./src/client/view/admin/model/contributors/contributors.js